<template>
    <!-- <input type="text" v-model="dValue" @nput="elInput(e)" @focus="checkstate($event)" @blur="checkstate($event);elBlur(e)" /> -->
    <b-input type="text" size="xs" placeholder="0.00" style="height: 30px; text-align:right;" v-model="dValue" @nput="elInput($event)" @focus="checkstate($event)" @blur="checkstate($event);elBlur($event)" ></b-input>
</template>
<script>
import { Decimal } from 'decimal.js'
import { apiUrl, xtools } from '@/constants/config'
let vc = {
  props: ['value', 'decimals'],
  data () {
    return {
      isFocus: false
    }
  },
  methods: {
    checkstate (e) {
      this.isFocus = e.type === 'focus'
    },
    elBlur (e) {
      this.$emit('el-blur', e)
    },
    elInput (e) {
      this.$emit('el-input', e)
    }
  },
  computed: {
    dValue: {
      get () {
        let dec = xtools.dec(this.decimals || 0)
        let val = this.value

        if (xtools.isEmpty(val)) return ''

        let deci = new Decimal(parseFloat(val))
        if (deci.isNaN()) { return val }
        let ret = ''

        if (this.isFocus) {
          ret = val.toString().replace(/,/g, '')
        } else {
          ret = xtools.formatNumber(deci.toFixed(10), dec)
        }

        return ret
      },
      set (newValue) {
        if (xtools.isEmpty(newValue)) {
          this.$emit('input', '')
          return
        }

        let f = parseFloat(newValue)
        if (isNaN(f)) {
          this.$emit('input', newValue)
          return
        }

        let dd = new Decimal(f)
        let dec = xtools.dec(this.decimals || 0)
        this.$emit('input', xtools.dec(dd.toFixed(10), dec))
      }
    }
  }
}
export default vc
</script>
